import React from 'react';
import CommonModal from '@components/common/CommonModal';
import './index.css';
import RedInfoIcon from '../../../../assets/svg/exclamation.svg';
import Button from '@components/common/Button';
import { buttonNames } from '@constants/appConstants';
import {status_type } from '@constants/sessionSiteConstant';
import { WarningModalProps } from '../vhnd-interface';


const SessionSiteWarningModal: React.FC<WarningModalProps> = ({ handleCloseModal, sessionStatusType, showWarningModal, handleWarningModalBackButton, handleFinalProceed }) => {

  return (
    <CommonModal
      show={showWarningModal}
      handleClose={handleCloseModal}
      handleCustomBackButton={handleWarningModalBackButton}
      conditionalClass="modal_component dynamic_form_field sesionSite"
      showCustomHeader={true}
      title=""
      size="md"
      footer={
        <div className='sessionSite-warning-btn-container'>
          <Button
            onClick={handleCloseModal}
            id={buttonNames.no}
            buttonName={buttonNames.no}
            colorType={'save'}
          />
          <Button
            onClick={() => handleFinalProceed(sessionStatusType == status_type.cancle.session_status_name ? status_type.cancle.session_status_code : status_type.confirm.session_status_code)}
            id={buttonNames.yes}
            buttonName={buttonNames.yes}
            colorType={'primary'}
          />
        </div>
      }
    >
      <div className='sessionSite-warning-modal'>
        <div className='icon-class'><RedInfoIcon /></div>
        <div className='warning-text'>Are you ready to <span className='text-bold'>{sessionStatusType}</span> the session?</div>
      </div>
    </CommonModal>
  );
};

export default SessionSiteWarningModal;
